<template>
    <div class="menu fs14 pt-5 pl-5">
        <i @click="closeMenu" class="fas fa-times text-white position-absolute fs14"></i>
        <nav @click="closeMenu" class="d-flex flex-column text-white pt-4">
            <router-link to="/about">About us</router-link>
            <router-link to="/grants" class="pt-3">Grants</router-link>
            <router-link to="/impact" class="pt-3">Impact</router-link>
            <router-link to="/contact" class="pt-3">Contact</router-link>
        </nav>
    </div>
</template>

<script>
export default {
    props: ['menuItems'],
    methods:{
        closeMenu(){
            this.$emit('changeMenu');
        }
    }
}
</script>

<style scoped>
.menu{
    min-width: 260px;
    background: #428193;
    color: white;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    top: 0;
    height: 100vh;
    z-index: 2;
}
.fa-times{ top: 2.7rem; right: 1.1rem;}


.overlay {
  width: 100%;
  height: 100%;
  transition: .3s ease;
  opacity: 0;
  border-left: 8px solid #5584ff;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

button{
    display: none;
    width: 140px;
    margin: 1rem auto;
}
@media only screen and (max-width: 990px) {
    button{
    display: block;
    }
}
</style>
